"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FInputText = void 0;
const react_1 = __importDefault(require("react"));
const FInputText = (_a) => {
    var { type = "text", display = "flex", label = "", placeholder = "", className = "", name = "", id = "", value = "", min = "0", max = "10", onChange = () => { }, validations, register, required, error, disabled = false, readonly = false } = _a, otherProps = __rest(_a, ["type", "display", "label", "placeholder", "className", "name", "id", "value", "min", "max", "onChange", "validations", "register", "required", "error", "disabled", "readonly"]);
    return (react_1.default.createElement("div", { className: `f-input-group ${display ? `d-${display}` : ""}` },
        label && react_1.default.createElement("label", { className: "w-100" }, label),
        react_1.default.createElement("input", Object.assign({ className: `f-input-control ${className}`, placeholder: `${placeholder}`, type: type }, (register
            ? register(name, Object.assign({}, validations))
            : { value: value, onChange: onChange }), { disabled: disabled, readOnly: readonly }, otherProps))));
};
exports.FInputText = FInputText;
//# sourceMappingURL=FthemeBuilderInputText.js.map